module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJ1BMVEUAAAA0NDQzMzMyMjIzMzMzMzMyMjIyMjIzMzMzMzM2NjYgICAzMzNiyMiBAAAADHRSTlMAQL9/blXp36CSEwgrlLeZAAAAdElEQVQI1zWNMQ6DQAwE1yZVdMWFtBRGaSlOqfkJLSWP4UlwgKDwo1idxFhrrWVrDSIRhdr9B6L5U/WJpueiytTGm6GJ0CSdH2oIKbR6yIKGJZfsxbxPWRGiWu2TQU08f0fmr8+LLnGimMgkA/m7tyi8ZrYbKmkWGOAZBFcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/HellowWorld/email_img.png
// module id = Erl/
// module chunks = 41